import React from 'react';
import { useHistory } from 'react-router-dom';
import Modal from 'components/Modal';
import ModalBody from 'components/Modal/ModalBody';
import Paragraph from 'components/Paragraph';
import Strong from 'components/Strong';
import RoundedButton from 'components/RoundedButton';
import { useTransferBookingContext } from 'modules/host-transfer-booking/context/TransferBookingContext';

const CSS = require('./DeclineTransferModal.less');

function DeclineTransferModal() {
  const history = useHistory();
  const { rejectTransfer } = useTransferBookingContext();

  const handleDeclineConfirmation = async () => {
    await rejectTransfer();
    history.goBack();
  }

  return (
    <Modal show onClose={history.goBack}>
      <ModalBody className={CSS.ModalBody}>
        <h1 className={CSS.Title}>Decline this transfer</h1>
        <Paragraph className={CSS.Paragraph}>
          <Strong weight="medium">Don't want to take this booking?</Strong> No worries, declining will not impact your performance statistics.
        </Paragraph>
        <Paragraph className={CSS.Paragraph}>
          <Strong weight="medium">Simply confirm your choice below.</Strong>
        </Paragraph>
        <RoundedButton size="S" onClick={handleDeclineConfirmation}>Decline transfer</RoundedButton>
        <RoundedButton size="S" inverted onClick={history.goBack}>Cancel</RoundedButton>
      </ModalBody>
    </Modal>
  );
}

export default DeclineTransferModal;
